import { Component, OnInit, ChangeDetectorRef, AfterViewInit, ViewChild, Inject } from '@angular/core';
import { SettingsHttpService } from '../../../../../app/core/settings/_services/settings-http.service';
import { ActivatedRoute } from '@angular/router';
import { Cache } from 'aws-amplify';
import { MachineRouteService } from '../machine-route.service';
import { MatTableDataSource, MatPaginator, MatSort, MatDialogRef,
	MAT_DIALOG_DATA, MatDialogConfig, MatSnackBar, MatDialog } from '@angular/material';
import { UpdatesDataSource } from '../../../../../app/core/settings';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModeWarnComponent } from './update-dialogs/mode-warn.component';
import { environment } from '../../../../../environments/environment';
import { MixpanelService } from '../../../../../app/services/mixpanel.service';
import { SelectOption } from '../../../partials/content/general/searchable-select/searchable-select.component';

@Component({
  selector: 'kt-updates',
  templateUrl: './updates.component.html',
  styleUrls: ['./updates.component.css']
})
export class UpdatesComponent implements OnInit, AfterViewInit {

	selectedMachine: any;

	dispColsVer = ['ui_cv', 'ui_av', 'aux_cv', 'aux_av', 'menu_cv', 'menu_av'];

	typeSelected: string | number | null = null;

	modeSelected: string | number | null = null;

	typeOptions: SelectOption[] = [];
	modeOptions: SelectOption[] = [
		{ value: 'engg', label: 'Engineering Review' },
		{ value: 'curr', label: 'Current' },
		{ value: 'arch', label: 'Archived' }
	];

	currVer: any;

	qParams;

	userRole = Cache.getItem('userAttr')['custom:role'];

	roleIndex;

	types = [
		{text: 'UI', value: 'ui', roles: ['sadmin']},
		{text: 'Menu', value: 'menu', roles: ['sadmin', 'distiadmin']},
		{text: 'VMC', value: 'aux', roles: ['sadmin']}
	];



	modes = [
		{text: 'Engineering Review', value: 'engg'},
		{text: 'Current', value: 'curr'},
		{text: 'Archived', value: 'arch'}
	];

	displayedColumns = ['file_version', 'file_desc', 'file_name', 'uploaded_at', 'actions'];

	@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

	@ViewChild(MatSort, {static: false}) sort: MatSort;

	dataSource: UpdatesDataSource;

	versionData = new MatTableDataSource();

	constructor(private http: SettingsHttpService, private cdr: ChangeDetectorRef, public dialog: MatDialog,
				private modalService: NgbModal,
				private _snackBar: MatSnackBar,
				private mixpanelService: MixpanelService,
				private route: ActivatedRoute,
				private machineRouteService: MachineRouteService) {
					this.roleIndex = environment.roles.indexOf(this.userRole);
									}

	ngOnInit() {
		this.selectedMachine = this.machineRouteService.getMachine(this.route);
		if (!this.selectedMachine) return;
		this.types = this.types.filter(type => type.roles.includes(this.userRole));

		// Convert types to SelectOption format
		this.typeOptions = this.types.map(type => ({
			value: type.value,
			label: type.text
		}));

		this.getCurrVersions();

		this.dataSource = new UpdatesDataSource(this.http);
		this.qParams = {
			noPerPg: 5,
			pgNo: 0,
			sortKey: 'uploaded_at',
			sortVal: 'desc',
			optFilterKey: 'file_type',
			optFilterVal: '',
			txtFilterKey: 'file_mode',
			txtFilterVal: ''
		};

this.mixpanelService.track(this.mixpanelService.PAGE_VIEW, {
			machine_id: this.selectedMachine.machine_id,
			machine_name: this.selectedMachine.machine_name,
			machine_serial_no: this.selectedMachine.serial_no
		});
	}

	ngAfterViewInit() {
		this.types = this.types.filter(type => type.roles.includes(this.userRole));

		// Update typeOptions after filtering
		this.typeOptions = this.types.map(type => ({
			value: type.value,
			label: type.text
		}));

		this.dataSource.counter$
		.pipe(
			tap((count) => {
			this.paginator.length = count;
			})
		)
		.subscribe();

		this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

		merge(this.paginator.page, this.sort.sortChange).pipe(
			tap(() => {
				this.loadPackageListPage();
			})
		)
		.subscribe();
	}

	typeChanged(val: string | number | null) {
		this.typeSelected = val;
		if (val && this.modeSelected) {
			this.loadPackageListPage();
		}
	}

	modeChanged(val: string | number | null) {
		this.modeSelected = val;
		if (val && this.typeSelected) {
			this.loadPackageListPage();
		}
	}

	getCurrVersions() {
		this.http.getVersion(this.selectedMachine.machine_id)
		.subscribe(versionDataD => {
			console.log(versionDataD);
			if(versionDataD){
				let versionData = versionDataD;
				// console.log(versionData);
				this.versionData.data = [versionData];
				this.currVer = versionData;
				this.updateChanges();
			}
		});
	}

	loadPackageListPage() {
		const typeValue = this.typeSelected || '';
		const modeValue = this.modeSelected || '';

		const params = {
			noPerPg: this.paginator.pageSize || 5,
			pgNo: this.paginator.pageIndex || 0,
			sortKey: this.sort.active,
			sortVal: this.sort.direction,
			optFilterKey: 'file_type',
			optFilterVal: typeValue,
			txtFilterKey: 'file_mode',
			txtFilterVal: modeValue
			// currVer: this.currVer[`${this.typeSelected}_cv`] || ''
		};

		// console.log(params);
		// console.log("Curr Version", this.currVer[`${this.typeSelected}_cv`]);
		this.dataSource.loadPackageList(params);
		this.updateChanges();
	}

	updateChanges() {
		this.cdr.detectChanges();
	}

	checkMode(file: any) {
		const modeValue = this.modeSelected || '';
		if (modeValue !== 'curr') {
			const dialogConfig = new MatDialogConfig();
			dialogConfig.autoFocus = true;
			dialogConfig.data = {
				txt:
				`The file which you are trying to assign is in ${ this.parseModeAbb(modeValue)} mode. Do you still want to proceed?`,
				access: true
			};
			const dialogRef = this.dialog.open(ModeWarnComponent, dialogConfig);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				} else {
					// console.log('returned:', res);
					if (res.success) {
						this.checkCompatible(file);
					}
				}
			});
		} else {
			this.checkCompatible(file);
		}
	}

	parseModeAbb(mode) {
		// console.log(mode);
		if (mode === 'engg') {
			return 'Engineering';
		} else if (mode === 'arch') {
			return 'Archive';
		}
	}

	checkCompatible(file: any) {
		if (file.file_type === 'ui') {
			this.assignFile(file);
		} else {

			const dialogConfig = new MatDialogConfig();
			dialogConfig.autoFocus = true;

			if (!file.file_comp) {
				dialogConfig.data = {
					txt:
					`No Compatibles added to this file, Do you still want to Procced?`,
					access: true
				};
			} else if (!file.file_comp.includes(this.currVer.ui_cv)) {
				dialogConfig.data = {
					txt:
					`Machine UI needs to be in ${file.file_comp.replace(',', '/')}, Do you still want to Procced?`,
					access: true
				};
			} else {
				this.assignFile(file);
				return;
			}
			// // console.log(file.file_comp, dialogConfig.data);
			const dialogRef = this.dialog.open(ModeWarnComponent, dialogConfig);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				} else {
					// console.log('returned:', res);
					if (res.success) {
						this.assignFile(file);
					}
				}
			});
		}
	}

	assignFile(file) {
		file.machine_id = this.selectedMachine.machine_id;
		file.serial_no = this.selectedMachine.serial_no;
		// console.log(file);
		this.http.assignLink(file)
		.subscribe(result => {
			if (result.data.success) {
				this.showSnackBar('Assigned successfully', 3000);
			} else {
				this.showSnackBar(result, 0);
			}
			this.getCurrVersions();
		}, error => {
			this.showSnackBar('Unable to assign, Something went wrong', 0);
		});
	}

	showSnackBar(message, duration) {
		let snackRef = this._snackBar.open(message, 'close');
		if (duration > 0) {
			setTimeout(() => {
				this._snackBar.dismiss();
			}, duration);
		}

		snackRef.onAction().subscribe(() => {
			this._snackBar.dismiss();
		});
	}
}
